import React from 'react';

import SatModal from './SatModal';

// 이미지 모달
const SatImgModal = props => {
  const { visible, setVisible, path } = props;
  return (
    <SatModal visible={visible} setVisible={setVisible} wide>
      <img src={`${process.env.STATIC_PATH}/images/${path}`} />
    </SatModal>
  );
};

export default SatImgModal;
